import { baseApi } from './baseApi';
import type { CategoryWithChildren, CategoryBreadcrumb } from '@nimbazaar/types';
import { API_ENDPOINTS } from '@nimbazaar/constants';

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data: T;
}

export const categoriesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategoryTree: builder.query<ApiResponse<CategoryWithChildren[]>, void>({
      query: () => API_ENDPOINTS.CATEGORIES.TREE,
      providesTags: ['Categories'],
    }),
    getCategoryBySlug: builder.query<ApiResponse<CategoryWithChildren>, string>({
      query: (slug) => API_ENDPOINTS.CATEGORIES.BY_SLUG(slug),
      providesTags: (result, error, slug) => [{ type: 'Categories', id: slug }],
    }),
    getCategoryBreadcrumb: builder.query<ApiResponse<{ breadcrumbs: CategoryBreadcrumb[]; current: CategoryWithChildren; children: CategoryWithChildren[] }>, string>({
      query: (id) => API_ENDPOINTS.CATEGORIES.BREADCRUMB(id),
      providesTags: ['Categories'],
    }),
  }),
});

export const {
  useGetCategoryTreeQuery,
  useGetCategoryBySlugQuery,
  useGetCategoryBreadcrumbQuery,
} = categoriesApi;
